import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Login from '@/components/Login'

import MainLayout from '@/components/layout/MainLayout'
import MainMap from '@/components/map/Main'

import Actuaciones from '@/components/actuaciones/Actuaciones'
import Medios from '@/components/medios/Medios'
import PlanificacionMMTT from '@/components/planificacion/PlanificacionMMTT'
import PlanificacionMMAA from '@/components/planificacion/PlanificacionMMAA'

import Infraestructuras from '@/components/infraestructuras/Infraestructuras'

import NotFound from '@/components/NotFound'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'Map',
        component: MainMap
      },
      {
        path: 'actuaciones',
        name: 'Actuaciones',
        component: Actuaciones
      },
      {
        path: 'medios',
        name: 'Medios',
        component: Medios
      },
      // {
      //   path: 'planificacion_mmtt',
      //   name: 'Planificacion MMTT',
      //   component: PlanificacionMMTT
      // },
      {
        path: 'planificacion_mmaa',
        name: 'Planificacion MMAA',
        component: PlanificacionMMAA
      },
      {
        path: 'infraestructuras',
        name: 'Infraestructuras',
        component: Infraestructuras
      }
    ]
  },
  { // Capturar rutas no existentes
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = store.getters['auth/accessToken']
  if (!token && to.name !== 'Login') {
    router.push('/login')
  } else if (token && to.name === 'Login') {
    router.push('/')
  }

  next()
})

export default router
